function isStringEmpty(str: string): boolean {
  const isEmpty = str.length > 0 && /[^\s]/.test(str);

  return !isEmpty;
}

export default isStringEmpty;
